module.exports = __webpack_public_path__ + "static/media/0.eda013b9.png";